import React from "react"
import DatePicker from "react-datepicker"
import moment from "moment"
import { CalendarIcon, CloseIcon } from "../../Icons"
import PropTypes from "prop-types"
import "./react-datepicker.css"
import "./DateField.css"

class DateField extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      pickerPosition: "down"
    }
    this.ref = React.createRef()
  }

  handleChange = date => {
    const { name } = this.props.field
    const { setFieldValue, setFieldTouched } = this.props.form
    if (moment(date).isValid()) {
      setFieldValue(name, moment(date).format("YYYY-MM-DD"))
      setFieldTouched(name)
    } else {
      setFieldValue(name, "")
      setFieldTouched(name)
    }
  }

  clearDate = () => {
    const { name } = this.props.field
    const { setFieldValue } = this.props.form
    setFieldValue(name, "")
  }

  handleFocus = () => {
    const winHeight = window.innerHeight
    const { bottom } =
      (this.ref.current && this.ref.current.getBoundingClientRect()) || 0

    this.setState(state => ({
      ...state,
      pickerPosition: winHeight - bottom < 400 ? "up" : "down"
    }))
  }

  handleChangeRaw = e => {
    e.preventDefault()
  }

  render() {
    const {
      field,
      defaultDate,
      form: { touched, errors }
    } = this.props
    let status = "default"
    if (touched[field.name] && errors[field.name]) {
      status = "has-error"
    } else if (touched[field.name] && field.value && !errors[field.name]) {
      status = "is-fixed"
    }
    const month = parseInt(moment(field.value).format("M"))
    const day = parseInt(moment(field.value).format("D"))
    let clearDateLeft = "clear-date"
    if (!isNaN(month) && !isNaN(day))
      clearDateLeft += "-" + month.toString() + "-" + (day < 10 ? "1" : "2")

    return (
      <>
        <div
          className={`DateField ${status} ${this.state.pickerPosition} ${
            this.props.disabled ? "disabled" : ""
          }`}
          ref={this.ref}
        >
          <label
            className="open-picker"
            htmlFor={`date-field-${this.props.field.name}`}
          >
            <CalendarIcon />
          </label>
          <DatePicker
            selected={
              field.value
                ? moment(field.value)
                : (defaultDate && defaultDate) || null
            }
            id={`date-field-${field.name}`}
            name={field.name}
            dateFormat="MMMM D, YYYY"
            dateFormatCalendar="MMMM"
            minDate={this.props.minDate}
            maxDate={this.props.maxDate}
            popperModifiers={{
              flip: {
                behavior: ["bottom"] // don't allow it to flip to be above
              },
              preventOverflow: {
                enabled: false // tell it not to try to stay within the view (this prevents the popper from covering the element you clicked)
              },
              hide: {
                enabled: false // turn off since needs preventOverflow to be enabled
              }
            }}
            showYearDropdown
            yearDropdownItemNumber={this.props.yearDropdownItemNumber}
            popperPlacement="bottom-end"
            onChange={this.handleChange}
            onChangeRaw={this.handleChangeRaw}
            onFocus={this.handleFocus}
            disabled={this.props.disabled}
          />
          {field.value &&
            !this.props.disabled && (
              <span
                className={`clear-date ${clearDateLeft}`}
                onClick={this.clearDate}
              >
                <CloseIcon />
              </span>
            )}
        </div>
        {touched[field.name] &&
          errors[field.name] && (
            <div className="error-message">{errors[field.name]}</div>
          )}
      </>
    )
  }
}

DateField.propTypes = {
  maxDate: PropTypes.object,
  selected: PropTypes.string,
  yearDropdownItemNumber: PropTypes.number,
  disabled: PropTypes.bool
}

DateField.defaultProps = {
  maxDate: moment(),
  yearDropdownItemNumber: 100,
  disabled: false
}

export default DateField
